import React from 'react'
import { Card, CardActionArea, CardContent, CardMedia, Typography, Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { Lesson as ILesson, Course as ICourse } from '../../../../types/academy'
import { isNew } from '../../../utils/academy'
import Image from 'next/image'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    marginTop: '20px',
    flexDirection: 'column',
    maxWidth: '320px',
    background: 'unset',
    backgroundColor: 'unset',
  },
  text: {
    color: theme.palette.primary.main,
  },
  image: {
    width: '100%',
    height: '160px',
    position: 'relative',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  content: {
    padding: '10px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  chip: {
    padding: '4px',
    width: 'fit-content',
    marginBottom: '4px',
    position: 'absolute',
    top: '10px',
    right: '10px',
    backgroundColor: 'white',
    color: theme.palette.primary.main,
    borderRadius: '8px',
    fontWeight: 'bold',
  },
  title: {
    fontSize: '16px',
    fontWeight: 'bold',
  },
  button: {
    width: 'fit-content',
    background: '#895DD1',
    height: 'unset',
    borderRadius: 8,
    padding: '8px 24px',
    fontFamily: theme.typography.fontFamily,
    textTransform: 'none',
    fontWeight: 'normal',
  },
  actionArea: {
    postion: 'relative',
    '&:hover $focusHighlight': {
      opacity: 0,
    },
  },
  focusHighlight: {},
}))

interface Props {
  lesson: ILesson
  view?: 'course' | 'lesson'
  course?: ICourse
}

function LessonCard({ lesson, view, course }: Props): JSX.Element {
  const classes = useStyles({})
  const { title, slug, createdAt } = lesson
  let url = ''
  switch (view) {
    case 'course':
      if (course) {
        url = course.lessons.length > 1 ? `/courses/${course.slug}/lesson/${lesson.slug}` : '#'
      } else {
        url = '#'
      }

      break
    case 'lesson':
      url = `/lesson/${slug}`
      break
    default:
      url = `/lesson/${slug}`
      break
  }

  return (
    <Card elevation={0} className={classes.root}>
      <CardActionArea
        classes={{ root: classes.actionArea, focusHighlight: classes.focusHighlight }}
        href={url}
        disableRipple
      >
        <div className={classes.image}>
          <Image layout="fill" objectFit="cover" src={lesson.image.url} />
        </div>
        {isNew(new Date(createdAt)) ? (
          <Chip label="New" size="small" className={classes.chip} />
        ) : null}
        <CardContent className={classes.content}>
          <Typography variant="body1" className={classes.title}>
            {title}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default LessonCard
